<template>
  <b-row align-h="center">
    <div class="w-75">
      <FITModal ref="deletePolicyModal" reference="deletePolicy" :title="$t('osm.contents.general.delete')" @click="onClickModalDelete">
        <div slot="body">
          <div class="my-4">
            <h5 v-html="$t('osm.contents.general.deletePolicyConfirm',{policyNumber: generalInfo.policyNumber, policyRef: generalInfo.policyReference})"></h5>
          </div>
        </div>
      </FITModal>
      <b-modal id="cbModal" :size="'lg'" ref="cbModal" @ok="onClickModalOk" :ok-variant="isFirstTimeClickedModalOk?'primary':'success'" cancel-variant="danger" @hidden="onHideModal" :title="$t('osm.contents.general.changeBusiness.title') + ' - ' + $t(`osm.contents.general.changeBusiness.${this.selectedChangeBusinessAction}`)">
        <div>
          <p v-html="changeBusinessConfirmContent"></p>
        </div>
        <div class="mt-3">
          <div class="w-50">
            <FITDatePicker v-if="selectedChangeBusinessAction != 'changePremiumType'" :label="$t(`osm.contents.general.changeBusiness.${selectedChangeBusinessAction}`) +' '+$t('general.date')" :width="8" v-model="changeBusinessEffectDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
          </div>
          <FITSelect v-if="selectedChangeBusinessAction == 'changePremiumType'" :label="$t('osm.contents.lifePolicy.generalInformation.premiumType')" :width="8" :options="getTranslatedOptions(`${$i18n.locale}`,premiumTypeList)" v-model="newPremiumType"></FITSelect>
          <FITWorkflowFileUpload ref="fitFileUpload"></FITWorkflowFileUpload>
        </div>
        <div v-if="!isFirstTimeClickedModalOk" class="my-4">
          <h5 v-html="changeBusinessWarning" style="color:red"></h5>
        </div>
        <b-alert :show="modalAlertCd" dismissible variant="danger" @dismissed="modalAlertCd=0">{{$t('general.updateError')}}</b-alert>
      </b-modal>
      <b-alert :show="dismissCountDown" dismissible :variant="submitSuccess?'success':'danger'" @dismissed="dismissCountDown=0">{{$t('general.updateSuccess')}}</b-alert>
      <FITFormCard>
        <b-row slot="header" align-v="center">
          <b-col cols="6">
            <h5><i class="fa fa-info-circle mr-2"></i>{{$t('osm.contents.lifePolicy.generalInfo')}}</h5></b-col>
          <b-col cols="6" class="text-right">
            <!-- <b-btn variant="warning" class="mr-2" @click="">{{$t('osm.contents.general.serviceRequest')}}</b-btn> -->
            <FITButton v-if="permissionLevel<3.5" class="mr-3" @click="onClickDeletePolicy" variant="warning" :text="$t('osm.contents.general.delete')" size="md"></FITButton>
            <!-- <FITDropdown v-if="permissionLevel<3.5" v-model="changeBusinessActions.value.action" variant="primary" :text="changeBusinessActions.label" :options="changeBusinessActions.options" @clicked="onClickChangeBusiness"></FITDropdown> -->
          </b-col>
        </b-row>
        <div slot="formBody">
          <b-row>
            <b-col cols="7">
              <h3><b><i class="fa fa-align-justify mr-2"></i>{{$t('osm.contents.lifePolicy.general')}}</b></h3>
              <div class="mt-3">
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.productName')" :value="productFullName"></LifePolicyDetailRow>
                <!-- <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.policyType')" :value="getTranslatedPolicyInfoValue('policyType',generalInfo.policyType)"></LifePolicyDetailRow>
 -->
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.policyNumber')" :value="generalInfo.policyNumber | isFieldEmpty"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.policyReference')" :value="generalInfo.policyReference"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.applicationDate')" :value="generalInfo.applicationDate | date"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.applicationReceivedDate')" :value="generalInfo.applicationReceivedDate | date"></LifePolicyDetailRow>
                <!-- <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.newBusinessOrRenewal')" :value="getTranslatedPolicyInfoValue('newBusinessOrRenewal',generalInfo.newBusinessOrRenewal)"></LifePolicyDetailRow> -->
                <!-- <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.originalAgent')" :value="originalAgent.english + ' ' + originalAgent.chinese"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.currentAgent')" :value="currentAgent.english + ' ' + currentAgent.chinese"></LifePolicyDetailRow> -->
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.approveAgent')" :value="approveAgentFullName | isEmpty"></LifePolicyDetailRow>
                <!-- <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.originalReferrer')" :value="originalReferrerFullName | isEmpty"></LifePolicyDetailRow> -->
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.policyOwner')" :value="policyOwnerFullName | isEmpty"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.insurer')" :value="insuererFullName | isEmpty"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.issueDate')" :value="generalInfo.issueDate | date"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.commencementDate')" :value="generalInfo.commencementDate | date"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.policyTerm')" :value="generalInfo.policyTerm"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.paymentTerm')" :value="generalInfo.paymentTerm | isFieldEmpty"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.conditionalAssignmentFlag')" :value="yesNo(generalInfo.conditionalAssignmentFlag) "></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.remarks')" :value="generalInfo.remarks | isFieldEmpty"></LifePolicyDetailRow>
                <!-- Attachment part -->
                <template>
                  <dl class="row">
                    <dt class="col-5">{{$t('osm.contents.lifePolicy.generalInformation.attachment')}}</dt>
                    <dd class="col-7">
                      <ul class="list-unstyled">
                        <template v-if="generalInfo.attachment.length > 0" v-for="item in generalInfo.attachment">
                          <li><a :href="fileDownloadPrefix+ item.ID">{{item.documentName}}</a></li>
                        </template>
                        <li v-if="generalInfo.attachment.length == 0">N/A</li>
                      </ul>
                    </dd>
                  </dl>
                </template>
              </div>
            </b-col>
            <b-col cols="auto" class="ml-auto">
              <p class="h5 bg-danger text-white ml-auto p-2 rounded">{{ $t('osm.contents.lifePolicy.generalInformation.policyStatus') }}: {{getTranslatedPolicyInfoValue('policyStatus', generalInfo.policyStatus)}}</p>
            </b-col>
            <!-- <b-col cols="5" class="border-left border-grey">
              <h3><b><i class="fa fa-credit-card mr-2"></i>{{$t('osm.contents.lifePolicy.fee')}}</b></h3>
              <div class="mt-3">
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.premiumAmount')" :value="generalInfo.premiumAmount"></LifePolicyDetailRow>
              </div>
</b-col>
 -->
          </b-row>
          <PolicyAgent v-model="policyAgent" translateKey="osm.contents.lifePolicy.generalInformation.policyAgent" :disabledName="true" :allDisabled="isAgentLocked">
            <div slot="rightTopSection">
              <b-row>
                <b-col cols="10">
                  <FITAlert ref="alert" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
                </b-col>
                <b-col v-if="permissionLevel<3.5" cols="auto" class="ml-auto">
                  <h3 v-if="isAgentLocked" @click="changeLockStatus" style="cursor:pointer" class="mt-2">
                      <i  class="fa fa-lock"></i>
                    </h3>
                  <b-btn v-else variant="primary" @click="onSaveAgent">{{$t('general.CURD.save')}}</b-btn>
                </b-col>
              </b-row>
            </div>
            <div slot="afterSection">
              <FITTextarea :width="10" v-model="policyAgentChangeReason" :label="$t('osm.contents.general.agentRemarks')" :disabled="isAgentLocked"></FITTextarea>
            </div>
          </PolicyAgent>
          <hr>
          <b-row>
            <b-col cols="6">
              <h3><b><i class="fa fa-university mr-2"></i>{{$t('osm.contents.lifePolicy.payment')}}</b></h3>
              <div class="mt-3">
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.policyCurrency')" :value="generalInfo.policyCurrency | isFieldEmpty"></LifePolicyDetailRow>
                <!-- <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.totalSinglePremiumPaid')" :value="'$' + generalInfo.totalSinglePremiumPaid | isFieldEmpty"></LifePolicyDetailRow> -->
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.initialPremium')" :value="'$' + generalInfo.initialPremium | isFieldEmpty"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.levy')" :value="'$' + generalInfo.levy | isFieldEmpty"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.modalPremium')" :value="'$' + generalInfo.modalPremium | isFieldEmpty"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.paymentMethod')" :value="getTranslatedPolicyInfoValue('paymentMethod',generalInfo.paymentMethod) "></LifePolicyDetailRow>
                <!-- <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.totalRegularPremiumPaid')" :value="'$' + generalInfo.totalRegularPremiumPaid | isFieldEmpty"></LifePolicyDetailRow> -->
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.totalPremiums')" :value="'$' + generalInfo.totalPremiums | isFieldEmpty"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.paymentMode')" :value="getTranslatedPolicyInfoValue('premiumType',generalInfo.premiumType) "></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.paymentDate')" :value="generalInfo.paymentDate | date"></LifePolicyDetailRow>
                <!-- <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.companyBank')" :value="getTranslatedPolicyInfoValue('companyBank',generalInfo.companyBank)"></LifePolicyDetailRow> -->
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.paymentReference')" :value="generalInfo.paymentReference | isFieldEmpty"></LifePolicyDetailRow>
              </div>
            </b-col>
            <b-col cols="6" class="border-left border-grey">
              <h3><b><i class="fa fa-user-secret mr-2"></i>{{$t('osm.contents.lifePolicy.internalUse')}}</b></h3>
              <div class="mt-3">
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.sentOutMedium')" :value="getTranslatedPolicyInfoValue('sentOutMedium',generalInfo.sentOutMedium)"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.sentOutDate')" :value="generalInfo.sentOutDate | date"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.sentOutReference')" :value="generalInfo.sentOutReference"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.welcomeLetterSentOutDate')" :value="generalInfo.welcomeLetterSentOutDate | date"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.companyReceiveDate')" :value="generalInfo.companyReceiveDate | date"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.customerReceiveDate')" :value="generalInfo.customerReceiveDate | date"></LifePolicyDetailRow>
                <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.agentReceiveDate')" :value="generalInfo.agentReceiveDate | date"></LifePolicyDetailRow>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <hr>
              <h3><b><i class="fa fa-file mr-2"></i>{{$t('osm.contents.lifePolicy.generalInformation.riders.title')}}</b></h3>
              <div class='mt-3'>
                <b-row>
                  <b-col cols="12" v-for="(item,idx) in copyGeneralInfo.riders">
                    <ExistedRiderRow :index="idx" :riderDetail="item" :bus="bus"></ExistedRiderRow>
                  </b-col>
                  <b-col cols="12">
                    <RiderRow v-if="permissionLevel<3.5" :index="copyGeneralInfo.riders.length + 1" :bus="bus"></RiderRow>
                  </b-col>
                  <!-- <b-col cols="6">
                    <template v-for="(item,idx) in generalInfo.riders">
                      <div v-if="idx % 2 == 0">
                        <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.riders.description')" :value="item.riderDescription"></LifePolicyDetailRow>
                        <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.riders.riderPremium')" :value="'$' + item.riderPremium"></LifePolicyDetailRow>
                        <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.riders.riderStatus')" :value="getTranslatedPolicyInfoValue('riderStatus',item.riderStatus)"></LifePolicyDetailRow>
                        <hr>
                      </div>
                    </template>
                  </b-col>
                  <b-col cols="6" class="border-left border-grey">
                    <template v-for="(item,idx) in generalInfo.riders">
                      <div v-if="idx % 2 != 0 ">
                        <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.riders.description')" :value="item.riderDescription"></LifePolicyDetailRow>
                        <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.riders.riderPremium')" :value="'$' + item.riderPremium"></LifePolicyDetailRow>
                        <LifePolicyDetailRow :field="$t('osm.contents.lifePolicy.generalInformation.riders.riderStatus')" :value="getTranslatedPolicyInfoValue('riderStatus',item.riderStatus) "></LifePolicyDetailRow>
                        <hr>
                      </div>
                    </template>
                  </b-col> -->
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
    </div>
  </b-row>
</template>
<script type="text/javascript">
import { FITFormCard, FITDropdown, FITModal, FITDatePicker, FITWorkflowFileUpload, FITSelect, FITButton, FITTextarea, FITAlert } from '@/components'
import { mapGetters, mapState } from 'vuex'
import LifePolicyDetailRow from './LifePolicyDetailRow'
import { PolicyAgent } from '@/Osm/components'
import Vue from 'vue';
import { domain } from '@/api/api.js'
import ExistedRiderRow from './ExistedRiderRow'
import RiderRow from './RiderRow'

export default {
  name: 'LifePolicyDetail',
  created() {
    this.getSelectionsList();
    this.$store.commit({ type: 'LifePolicy/setPolicyID', ID: this.$route.query.ID })
    this.$store.dispatch('LifePolicy/getLifeDetail', true)
      .then(() => {
        // this.getAllName();
      });

    this.bus.$on('updateExistedRiderSuccess', (obj) => {
      if (obj.remove) {
        var copy = JSON.parse(JSON.stringify(this.copyGeneralInfo.riders));
        copy.splice(obj.index, 1);
        Vue.set(this.copyGeneralInfo, 'riders', copy);
      }
    });

    this.bus.$on('updateRiderSuccess', (obj) => {
      console.debug('updateRiderSuccess', obj);
      if (obj.remove) {
        var copy = JSON.parse(JSON.stringify(this.copyGeneralInfo.riders));
        copy.splice(obj.index, 1);
        Vue.set(this.copyGeneralInfo, 'riders', copy);
      } else {
        this.copyGeneralInfo.riders.push(obj);
      }
    });
  },
  methods: {
    changeLockStatus() {
      Vue.set(this, 'isAgentLocked', !this.isAgentLocked);
    },
    onSaveAgent() {
      this.policyAgent.forEach((item, index, object) => {
        if (item.agentID == null || item.agentID == 0) {
          object.splice(index, 1);
        }
      })
      console.debug(this.policyAgent);
      return;
      this.$store.dispatch('LifePolicy/editPolicyAgent', {
        policyID: this.generalInfo.ID,
        policyAgent: this.policyAgent,
        policyAgentChangeReason: this.policyAgentChangeReason,
        policyType: 'P'
      }).then((json) => {
        this.policyAgent.forEach((item) => {
          if (item.isExist) {
            return;
          }
          item.isExist = true;
        })
        Vue.set(this, 'isAgentLocked', true);
        this.$refs.alert.showAlert();
      })
    },
    onClickModalDelete(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('LifePolicy/deleteLifePolicy', this.generalInfo.ID).then((json) => {
        this.$refs.deletePolicyModal.closeModal();
        this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', 0);
        this.$router.replace({ name: 'Life Policy List', params: { alertContent: this.$t('osm.contents.general.deleteSuccess'), alertVariant: 'success' } });
      })
    },
    onClickDeletePolicy() {
      this.$refs.deletePolicyModal.openModal();
    },
    getOptions(columnName) {
      var obj = this.allSelections.filter((item) => { return item.name === columnName });
      if (obj[0] == null) {
        return []
      }
      if (obj[0].options.length == 0) {
        return null;
      }
      return obj[0].options;
    },
    onHideModal() {
      Vue.set(this, 'isFirstTimeClickedModalOk', true);
      Vue.set(this, 'changeBusinessEffectDate', '');
      Vue.set(this, 'newFileUploaded', {});
      this.$refs.fitFileUpload.removeAllFile();

    },
    onClickModalOk(evt) {
      evt.preventDefault();
      if (this.isFirstTimeClickedModalOk) {
        Vue.set(this, 'isFirstTimeClickedModalOk', false);
        Vue.set(this, 'submitSuccess', true);
        return;
      }
      var fileData = this.uploadFile();

      switch (this.selectedChangeBusinessAction) {
        case 'lapse':
          var params = { ID: this.generalInfo.ID, policyLapseDate: this.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment }
          this.$store.dispatch('LifePolicy/lapseLife', params).then(() => {
            this.$store.dispatch('LifePolicy/getLifeDetail', true);
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();
          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })

          break;
        case 'surrender':
          var params = { ID: this.generalInfo.ID, policyEndDate: this.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment }
          this.$store.dispatch('LifePolicy/surrenderLife', params).then(() => {
            this.$store.dispatch('LifePolicy/getLifeDetail', true);
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();

          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
        case 'reinstate':
          var params = { ID: this.generalInfo.ID, policyReinstateDate: this.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment }
          this.$store.dispatch('LifePolicy/reinstateLife', params).then(() => {
            this.$store.dispatch('LifePolicy/getLifeDetail', true);
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();
          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
        case 'transferOut':
          var params = { ID: this.generalInfo.ID, policyEndDate: this.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment };
          this.$store.dispatch('LifePolicy/transferOutLife', params).then(() => {
            this.$store.dispatch('LifePolicy/getLifeDetail', true);
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();

          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
        case 'changePremiumType':
          var params = { ID: this.generalInfo.ID, premiumType: this.newPremiumType, files: fileData.files, attachment: fileData.attachment };
          this.$store.dispatch('LifePolicy/changePremiumTypeLife', params).then(() => {
            this.$store.dispatch('LifePolicy/getLifeDetail', true);
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();

          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
      }

    },
    onClickChangeBusiness(actionType) {
      Vue.set(this, 'selectedChangeBusinessAction', actionType)
      this.$refs.cbModal.show()
    },
    getTranslatedPolicyInfoValue(fieldName, key) {
      console.debug(key);
      if (key == null || key.length == 0) return 'N/A';
      var obj = this.allSelections.filter((item) => { return item.name === fieldName });
      console.debug(obj);
      if (obj[0] == null) {
        return 'N/A'
      }
      if (obj[0].options.length == 0) {
        return 'N/A';
      }
      var filteredType = obj[0].options.filter((item) => {
        return item.selectionKey === key
      });
      var translatedData = this.getTranslatedOptions(this.$i18n.locale, filteredType);
      if (translatedData.length == 0) {
        return key
      }
      return translatedData[0].text
    },
    getAllName() {
      var productNamePayload = { optionType: "life", searchInput: { ID: this.generalInfo.productID } }
      this.searchOption(productNamePayload, (json) => {
        console.debug(json);
        Vue.set(this.productName, 'chinese', json[0].productChineseName);
        Vue.set(this.productName, 'english', json[0].productEnglishName);
      });
      this.searchAgentOrCustomer("customer", this.generalInfo.insurer, "insurer");
      this.searchAgentOrCustomer("customer", this.generalInfo.policyOwner, "policyOwner");
      this.searchAgentOrCustomer("agent", this.generalInfo.originalAgent, "originalAgent");
      this.searchAgentOrCustomer("agent", this.generalInfo.approveAgent, "approveAgent");
      this.searchAgentOrCustomer("agent", this.generalInfo.currentAgent, "currentAgent");
      this.searchAgentOrCustomer("agent", this.generalInfo.originalReferrer, "originalReferrer");
    },
    searchAgentOrCustomer(optionType, id, dataKey) {
      if (id == null || id == -1) {
        return;
      }
      var payload = { optionType: optionType, searchInput: { ID: id } }
      this.searchOption(payload, (json) => {
        console.debug(json);
        Vue.set(this[dataKey], 'english', json[0].englishFullname);
        Vue.set(this[dataKey], 'chinese', json[0].chineseFullname);
      });
    },
    searchOption(obj, success) {
      var payload = {
        ...obj,
        ...{ dest: "option" },
      }
      this.$store.dispatch('searchOption', payload)
        .then((json) => {
          success(json);
        })
        .catch((err) => {
          console.debug(err);
        });
    },
    getSelectionsList() {
      this.$store.dispatch('getAllSelections', "life")
        .then((response) => {
          if (response.status != 200) {
            return;
          }
          Vue.set(this, 'allSelections', response.data);
          this.$store.commit({ type: 'LifePolicy/setLifeSelectionList', lifeSelectionList: response.data })
        }, (err) => {
          console.error(err);
        })
    },
    uploadFile() {
      var fileData = this.$refs.fitFileUpload.formUploadFiles();
      console.debug(fileData);
      Vue.set(this, 'newFileUploaded', fileData);
      return fileData;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    showModalAlert() {
      this.modalAlertCd = this.dismissSecs;
    },
    yesNo(val) {
      switch (val) {
        case "Y":
          return this.$t('general.yes');
        case "N":
          return this.$t('general.no');
        default:
          return 'N/A'
      }
    }
  },

  data() {
    return {
      alertParams: {
        content: this.$t('general.updateSuccess'),
        variant: 'success'
      },
      copyGeneralInfo: {
        riders: []
      },
      newRiders: 1,
      bus: new Vue(),
      modalAlertCd: 0,
      dismissSecs: 3,
      dismissCountDown: 0,
      submitSuccess: false,
      newFileUploaded: {},
      newPremiumType: '',
      changeBusinessEffectDate: '',
      isFirstTimeClickedModalOk: true,
      selectedChangeBusinessAction: '',
      fileDownloadPrefix: domain + '/dm/document/download?ID=',
      insurer: { chinese: 'N/A', english: '' },
      policyOwner: { chinese: 'N/A', english: '' },
      originalAgent: { chinese: 'N/A', english: '' },
      currentAgent: { chinese: 'N/A', english: '' },
      approveAgent: { chinese: 'N/A', english: '' },
      originalReferrer: { chinese: 'N/A', english: '' },
      productName: { chinese: 'N/A', english: '' },
      allSelections: [],
      changeBusinessActions: {
        value: { rowID: '', action: '' },
        key: 'actions',
        label: this.$t('osm.contents.general.changeBusiness.title'),
        options: [
          { text: this.$t('osm.contents.general.changeBusiness.lapse'), key: 'lapse' },
          { text: this.$t('osm.contents.general.changeBusiness.surrender'), key: 'surrender' },
          { text: this.$t('osm.contents.general.changeBusiness.reinstate'), key: 'reinstate' },
          { text: this.$t('osm.contents.general.changeBusiness.transferOut'), key: 'transferOut' },
          { text: this.$t('osm.contents.general.changeBusiness.changePremiumType'), key: 'changePremiumType' }
        ]
      },
      policyAgent: [],
      policyAgentChangeReason: '',
      isAgentLocked: true,
    }
  },

  watch: {
    generalInfo(val) {
      Vue.set(this, 'copyGeneralInfo', JSON.parse(JSON.stringify(val)));
    },
    'generalInfo.policyAgent': function(newData, oldData) {
      var policyAgent = JSON.parse(JSON.stringify(newData));
      policyAgent.forEach((item) => {
        item.isExist = true;
      })
      Vue.set(this, 'policyAgent', policyAgent);
    },
  },

  computed: {
    permissionLevel() {
      return this.$store.state.permissionLevel;
    },
    premiumTypeList() {
      return this.getOptions("premiumType");
    },
    ...mapGetters("LifePolicy", [
      'getTranslatedOptions'
    ]),
    ...mapState({
      generalInfo: state => state.LifePolicy.newLife.lifeGeneralInfo,
    }),

    productFullName() {
      if (this.generalInfo.productEnglishName == null) {
        return '';
      }
      return this.generalInfo.productEnglishName + ' ' + this.generalInfo.productChineseName;
    },
    approveAgentFullName() {
      if (this.generalInfo.englishNameApproveAgent == null) {
        return '';
      }
      return this.generalInfo.englishNameApproveAgent + ' ' + this.generalInfo.chineseNameApproveAgent
    },
    policyOwnerFullName() {
      if (this.generalInfo.englishNamePolicyOwner == null) {
        return '';
      }
      return this.generalInfo.englishNamePolicyOwner + ' ' + this.generalInfo.chineseNamePolicyOwner
    },
    originalReferrerFullName() {
      if (this.generalInfo.englishNameOriginalReferrer == null) {
        return '';
      }
      return this.generalInfo.englishNameOriginalReferrer + ' ' + this.generalInfo.chineseNameOriginalReferrer
    },
    insuererFullName() {
      if (this.generalInfo.englishNameInsuerer == null) {
        return '';
      }
      return this.generalInfo.englishNameInsuerer + ' ' + this.generalInfo.chineseNameInsuerer
    },

    filteredTypeInfo() {
      var disallowed = ['version', 'ID', 'generalPolicy']
      var filtered = Object.keys(this.typeInfo)
        .filter(key => !disallowed.includes(key))
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: this.typeInfo[key]
          };
        }, {});
      return filtered;
    },
    changeBusinessConfirmContent() {
      return this.$t('osm.contents.general.changeBusiness.confirmActionContent', {
        policyOwner: this.policyOwner.english + ' ' + this.policyOwner.chinese,
        policyNumber: this.generalInfo.policyNumber
      })
    },
    changeBusinessWarning() {
      return this.$t('osm.contents.general.changeBusiness.confirmActionWarning', {
        action: this.$t(`osm.contents.general.changeBusiness.${this.selectedChangeBusinessAction}`),
      })
    },

    changeBusinessDateFieldName() {
      switch (this.selectedChangeBusinessAction) {
        case 'lapse':
          //lapse
          return this.$t('osm.contents.general.changeBusiness.lapseDate')
        case 'surrender':
          // surrender
          return this.$t('osm.contents.general.changeBusiness.surrenderDate')
        case 'reinstate':
          //reinstate
          return this.$t('osm.contents.general.changeBusiness.reinstateDate')
        case 'transferOut':
          return this.$t('osm.contents.general.changeBusiness.transferOut')
        case 'changePremiumType':
          return this.$t('osm.contents.general.changeBusiness.changePremiumType')
      }
    }

  },
  filters: {
    isFieldEmpty(input) {
      return ((input != null && input.length > 0) ? input : 'N/A')
    },
  },
  destroyed() {
    this.$store.dispatch('LifePolicy/resetNewLifeState');
  },
  components: {
    FITFormCard,
    LifePolicyDetailRow,
    FITDropdown,
    FITModal,
    FITDatePicker,
    FITWorkflowFileUpload,
    FITSelect,
    ExistedRiderRow,
    RiderRow,
    FITButton,
    PolicyAgent,
    FITTextarea,
    FITAlert
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/components/LifePolicyDetail/LifePolicyDetail.vue